var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "space-around" } },
    [
      _c("loading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "v-tabs",
            {
              staticClass: "mt-3",
              attrs: {
                "show-arrows": "",
                color: "basil",
                grow: "",
                vertical: ""
              },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c(
                "v-tab",
                {
                  staticClass: "tab-border",
                  attrs: { "active-class": "tab-active" }
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "view.sales_force.reflect.label.tabs.torihikisaki"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isLinkComplete("torihikisakiStatus")
                    ? [
                        _c("v-icon", { attrs: { color: "orange" } }, [
                          _vm._v("mdi-alert")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-tab",
                {
                  staticClass: "tab-border",
                  attrs: { "active-class": "tab-active" }
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "view.sales_force.reflect.label.tabs.torihikisaki_sekininsya_apply"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isLinkComplete("torihikisakiSekininsyaApplyStatus")
                    ? [
                        _c("v-icon", { attrs: { color: "orange" } }, [
                          _vm._v("mdi-alert")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-tab",
                {
                  staticClass: "tab-border",
                  attrs: { "active-class": "tab-active" }
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "view.sales_force.reflect.label.tabs.torihikisaki_sekininsya_tanto"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isLinkComplete("torihikisakiSekininsyaTntoStatus")
                    ? [
                        _c("v-icon", { attrs: { color: "orange" } }, [
                          _vm._v("mdi-alert")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.showEntry()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_entry"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityEntryStatus") ||
                      !_vm.isLinkComplete("opportunityEntryItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showBasic()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_basic"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityBasicStatus") ||
                      !_vm.isLinkComplete("opportunityBasicItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMedium()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_medium"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityMediumStatus") ||
                      !_vm.isLinkComplete("opportunityMediumItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showStandard()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_standard"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityStandardStatus") ||
                      !_vm.isLinkComplete("opportunityStandardItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showProfessional()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_professional"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityProfessionalStatus") ||
                      !_vm.isLinkComplete("opportunityProfessionalItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMotionAi()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_motion_ai"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityMotionAiStatus") ||
                      !_vm.isLinkComplete("opportunityMotionAiItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showUpgrade()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_upgrade"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityToUpgradeStatus") ||
                      !_vm.isLinkComplete("opportunityToUpgradeItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAdditionalTablet()
                ? _c(
                    "v-tab",
                    {
                      staticClass: "tab-border",
                      staticStyle: { "text-transform": "none" },
                      attrs: { "active-class": "tab-active" }
                    },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_additional_tablet"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete(
                        "opportunityAdditionalTabletStatus"
                      ) ||
                      !_vm.isLinkComplete(
                        "opportunityAdditionalTabletItemStatus"
                      ) ||
                      !_vm.isLinkComplete(
                        "opportunityAdditionalTabletItemInitialFeeStatus"
                      )
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showKobetu()
                ? _c(
                    "v-tab",
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_kobetu"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityKobetuStatus") ||
                      !_vm.isLinkComplete("opportunityKobetuItemStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showOralCare()
                ? _c(
                    "v-tab",
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.tabs.opportunity_oral_care"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isLinkComplete("opportunityOralCareItemStatus") ||
                      !_vm.isLinkComplete("opportunityOralCareStatus")
                        ? [
                            _c("v-icon", { attrs: { color: "orange" } }, [
                              _vm._v("mdi-alert")
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-tab",
                {
                  staticClass: "tab-border",
                  attrs: { "active-class": "tab-active" }
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "view.sales_force.reflect.label.tabs.application_details"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isLinkComplete("applicationDetailStatus")
                    ? [
                        _c("v-icon", { attrs: { color: "orange" } }, [
                          _vm._v("mdi-alert")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "9" } },
        [
          _c(
            "v-card",
            { staticClass: "elevation-0" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0 pb-0 mb-0" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.apply_date"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "9" }
                            },
                            [
                              _c("label", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.parseDate(
                                      _vm.documentData["applyInfoApplyDate"]
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0 pb-0 mb-0" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.apply_person"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "9" }
                            },
                            [
                              _c("label", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.documentData[
                                      "officeInfoRequestPersonLastName"
                                    ]
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.documentData[
                                        "officeInfoRequestPersonFirstName"
                                      ]
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0 pb-0 mb-0" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.company_name"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "9" }
                            },
                            [
                              _c("label", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.documentData["officeInfoCompanyName"]
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0 pb-0 mb-0" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.office_name"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "9" }
                            },
                            [
                              _c("label", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.documentData["officeInfoOfficeName"]
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0 pb-0 mb-3" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.reflect_status"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "9" }
                            },
                            [
                              _vm.isLinkComplete("salesForceStatus")
                                ? [
                                    _c(
                                      "label",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "view.sales_force.reflect.label.status.renkeizumi"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "font-weight-bold",
                                        staticStyle: {
                                          color: "#ff9800!important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "view.sales_force.reflect.label.status.mirenkei"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-0",
                                  attrs: {
                                    type: "button",
                                    "x-small": "",
                                    depressed: "",
                                    fab: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.showStatusChangeDialog = true
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-pencil")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("simple-dialog", {
                                attrs: {
                                  "show-dialog": _vm.showStatusChangeDialog,
                                  "default-msg": _vm.getStatusChangeMsg()
                                },
                                on: {
                                  "ok-click": function($event) {
                                    return _vm.changeSalesForceStatus()
                                  },
                                  "cancel-click": function($event) {
                                    return _vm.dialogClose()
                                  }
                                }
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "pt-0 mt-0 pb-0 mb-0 " },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "6" }
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.current_user"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-0 pb-0 mb-0",
                              attrs: { cols: "6" }
                            },
                            [
                              _c("label", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(_vm.signInEmail))
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        [
                          _c("v-col", {
                            staticClass: "pt-0 mt-2 pb-0 mb-0",
                            attrs: { cols: "6" }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 mt-2 pb-0 mb-0",
                              attrs: { cols: "6" }
                            },
                            [
                              _c("move-sales-force-button", {
                                attrs: {
                                  "sales-force-id": _vm.salesForceUserId,
                                  "sales-force-type": "User"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  attrs: { dismissible: "", type: _vm.alertType },
                  model: {
                    value: _vm.showAlertFlg,
                    callback: function($$v) {
                      _vm.showAlertFlg = $$v
                    },
                    expression: "showAlertFlg"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.alertMessage) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  staticClass: "pa-3",
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    [
                      _c("torihikisaki", {
                        attrs: {
                          "init-data": _vm.documentData,
                          "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                          "init-sales-force-data": _vm.salesForceInfo
                        },
                        on: {
                          reflect: _vm.reflect,
                          "csv-output": _vm.csvOutput,
                          "re-correct": _vm.reCorrectUrlButtonClick
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c("torihikisaki-sekininsya-apply", {
                        attrs: {
                          "init-data": _vm.documentData,
                          "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                          "init-sales-force-data": _vm.salesForceInfo
                        },
                        on: {
                          reflect: _vm.reflect,
                          "csv-output": _vm.csvOutput,
                          "re-correct": _vm.reCorrectUrlButtonClick
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c("torihikisaki-sekininsya-tanto", {
                        attrs: {
                          "init-data": _vm.documentData,
                          "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                          "init-sales-force-data": _vm.salesForceInfo
                        },
                        on: {
                          reflect: _vm.reflect,
                          "csv-output": _vm.csvOutput,
                          "re-correct": _vm.reCorrectUrlButtonClick
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showEntry()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-entry", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataEntry,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showBasic()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-basic", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataBasic,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMedium()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-medium", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataMedium,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showStandard()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-standard", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataStandard,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showProfessional()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-professional", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataProfessional,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMotionAi()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-motion-ai", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataMotionAi,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showUpgrade()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-upgrade", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataUpgrade,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAdditionalTablet()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-additional-tablet", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data":
                                _vm.priceBook2DataAdditionalTablet,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showKobetu()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-kobetu", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2Data,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOralCare()
                    ? _c(
                        "v-tab-item",
                        [
                          _c("opportunity-oral-care", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2Data,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: {
                              reflect: _vm.reflect,
                              "csv-output": _vm.csvOutput,
                              "re-correct": _vm.reCorrectUrlButtonClick
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c("application-details", {
                        attrs: {
                          "init-data": _vm.documentData,
                          "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                          "is-linked": _vm.isLinkComplete(
                            "applicationDetailStatus"
                          ),
                          "init-sales-force-data": _vm.salesForceInfo
                        },
                        on: {
                          reflect: _vm.reflect,
                          "csv-output": _vm.csvOutput,
                          "re-correct": _vm.reCorrectUrlButtonClick
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "default-msg": _vm.alertDialogMessage,
          "is-confirm": false,
          "is-html": true
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showReCorrectDialog,
          "max-width": "800",
          "default-msg": _vm.$t(
            "view.sales_force.reflect.msg.confirm_re_correct"
          )
        },
        on: {
          "ok-click": function($event) {
            return _vm.reCorrect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAfterReCorrectDialog,
          "default-msg": _vm.$t(
            "view.sales_force.reflect.msg.confirm_after_re_correct"
          ),
          "max-width": "800"
        },
        on: {
          "ok-click": function($event) {
            return _vm.movePage()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a534911", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a534911","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sales_force/ReflectSalesForce.vue
// module id = mPce
// module chunks = 1